'use strict';

import searchMap from './searchMap';
import searchModePresentation from './searchModePresentation';
import searchFollowMap from './searchFollowMap';

export default function searchView () {
    searchMap();

    searchModePresentation();

    searchFollowMap();
}
